interface IConfig {
  debug: boolean;
  gMapsAPIKey: string;
  googleAnalyticsMeasurementId: string;
  reactAppHostUrl: string;
  apiBasePath: {
    atlantis: string;
    keymaker: string;
    dropbox: string;
    sherlock: string;
    yada: string;
    yenta: string;
    signature: string;
    leo: string;
  };
  imageBaseUrl: {
    yentaImageBaseUrl: string;
  };
  deployVersion: string;

  datadog: {
    applicationId: string;
    clientToken: string;
    deployVersion: string;
    releaseStage: string;
    sessionSampleRate: number;
    sessionReplaySampleRate: number;
  };
  realSignatureBaseUrl: string;
  boltBaseUrl: string;
  leoMediaBaseUrl: string;
  isRBOEnabled: boolean;
  rezenCampaignSessionTimeoutInMinutes: number;
}

const config: IConfig = {
  debug: process.env.VITE_DEBUG! === 'true',
  gMapsAPIKey: process.env.VITE_GOOGLE_MAPS_API_KEY!,
  googleAnalyticsMeasurementId:
    process.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID!,
  reactAppHostUrl: process.env.VITE_DEPLOY_URL!,
  apiBasePath: {
    atlantis: process.env.VITE_ATLANTIS_API_BASE!,
    keymaker: process.env.VITE_KEYMAKER_API_BASE!,
    dropbox: process.env.VITE_DROPBOX_API_BASE!,
    sherlock: process.env.VITE_SHERLOCK_API_BASE!,
    yada: process.env.VITE_YADA_API_BASE!,
    yenta: process.env.VITE_YENTA_API_BASE!,
    signature: process.env.VITE_SIGNATURE_API_BASE!,
    leo: process.env.VITE_LEO_API_BASE!,
  },
  imageBaseUrl: {
    yentaImageBaseUrl: process.env.VITE_YENTA_IMAGE_BASE_URL!,
  },

  datadog: {
    applicationId: process.env.VITE_DATADOG_APPLICATION_ID!,
    clientToken: process.env.VITE_DATADOG_CLIENT_TOKEN!,
    deployVersion: process.env.VITE_DEPLOY_VERSION!,
    sessionSampleRate: parseInt(
      process.env.VITE_DATADOG_SESSION_SAMPLE_RATE!,
      10,
    ),
    sessionReplaySampleRate: parseInt(
      process.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE!,
      10,
    ),
    releaseStage: process.env.VITE_DATADOG_RELEASE_STAGE!,
  },
  deployVersion: process.env.VITE_DEPLOY_VERSION!,
  realSignatureBaseUrl: process.env.VITE_SIGNATURE_BASE_PATH!,
  boltBaseUrl: process.env.VITE_BOLT_BASE_PATH!,
  leoMediaBaseUrl: process.env.VITE_LEO_MEDIA_BASE_URL!,
  isRBOEnabled: process.env.VITE_RBO_ENABLED! === 'true',
  rezenCampaignSessionTimeoutInMinutes: parseInt(
    process.env.VITE_REZEN_CAMPAIGN_SESSION_TIMEOUT_IN_MINUTES!,
    10,
  ),
};

export default config;
